module.exports = __webpack_public_path__ + "img/3877f1c6fa62dbe345356924acc1948f.3877f1c6.png";